export default "__VITE_ASSET__DAiIgEH7__"